<template>
  <div class="operate-box">
    <app-header :title="`${currentOrder.productName}开启门店`" @goback="goBack">
      <div slot="tips" @click="edit">
        <div class="header-right">{{this.isShowCheck ? '取消' : '编辑'}}</div>
      </div>
    </app-header>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="operate-list" ref="operateList">
        <li v-for="(item, index) in storeList" :key="index" @click="check(item, index)">
          <checkbox disabled v-model="checkedIds" class="list-checkbox" :value="item.id" v-show="isShowCheck" ref="checkbox" :class="{'disable-checkbox': item.status === 3 }"></checkbox>
          <div class="operate-right">
            <div class="operate-name">{{ productType === 1 ? item.deptName : item.deviceName }}</div>
            <div class="operate-bottom">
              <div class="operate-state">{{ caclStatus(item.status) }}</div>
              <div :class="{'operate-time': true, 'operate-time-color': item.status === 3}" @click="activate(item)">{{ caclText(item) }}</div>
            </div>
          </div>
        </li>
      </ul>
    </pull-to>
    <div class="btn-box" v-show="isShowCheck">
      <div @click="changeStatus(1)">开启</div>
      <div @click="changeStatus(2)">暂停</div>
      <div @click="changeStatus(3)">转出</div>
      <div @click="renew">续费</div>
    </div>
    <renew-modal @confirm="confirmRenew" :select-list="selectList"></renew-modal>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import { mapState, mapMutations } from 'vuex';
import apis from 'api/index';
import { Checkbox } from 'vue-checkbox-radio';
import PullTo from 'vue-pull-to';
import moment from 'moment';
import renewModal from 'components/renew-month-modal';

export default {
  mixins: [commonMixin],
  components: {
    Checkbox,
    PullTo,
    renewModal
  },
  data() {
    return {
      storeList: [],
      storeTotal: 0,
      pageNumber: 1,
      pageSize: 10,
      checkedIds: [],
      isShowCheck: false,
    }
  },
  computed: {
    isLoadAll() {
      return Boolean(this.storeTotal > this.pageNumber * this.pageSize);
    },
    productType() {
      return this.currentOrder.productType;
    },
    selectList() {
      // 先计算出当前选中的list集合
      return this.storeList.filter(item => {
        for(let i = 0; i < this.checkedIds.length; i++) {
          if(item.id === this.checkedIds[i]) {
            return item
          }
        }
      });
    },
    ...mapState(['currentOrder'])
  },
  created() {
    this.fetchStoreList('normal');
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 点击行选中
    check(item, index) {
      if(item.status === 3) return false;
      if(!this.isShowCheck) return false;
      this.$refs.checkbox[index].toggle(item.depId);
    },
    edit() {
      if(this.isShowCheck) {
        this.checkedIds = [];
      } 
      this.isShowCheck = !this.isShowCheck;
    },
    // 激活
    async activate(operateItem) {
      if(operateItem.status !== 3) {
        return false;
      }
      // 如果剩余数为0，就跳到别的订单里去让他选，否则就在自己订单里操作
      if(this.currentOrder.surplusNum === 0) {
        this.$router.push({name: 'choose-order', params: {id: operateItem.id}});
      } else {
        let params = {
          ids: [operateItem.id],
          status: 4,
          moduleOrderId: this.currentOrder.id
        }
        try {
          const res = await apis.updateRenewType(params);
          this.showToast('操作成功', 'success');
          this.pageNumber = 1;
          this.fetchStoreList('reset');
        } catch(err) {
          console.error(err);
        }
      }
    },
    async changeStatus(status) {
      if(this.checkedIds.length === 0) {
        this.showToast('请选择要操作的门店');
        return false;
      }
      let params = {};
      params.ids = this.checkedIds;
      params.status = status;
      if(status === 3) { // 转出和别的不太一样，首先只能对单个门店转出，其次要查出当前选择的门店的具体信息，跳转到选择门店页面去
        if(this.checkedIds.length > 1) {
          this.showToast('只能对单个门店进行转出');
          return false;
        }
        let select = this.storeList.filter(item => item.id === this.checkedIds[0])[0];
        this.setCurrentStore(select);
        this.$router.push({ path: `/choose-store/${this.currentOrder.moduleId}`, query: {type: 2} }); // type为2时，表示转换门店
      } else {
        const res = await apis.updateRenewType(params);
        this.showToast('操作成功', 'success');
        this.pageNumber = 1;
        this.fetchStoreList('reset');
      }
    },
    renew() {
      if(this.checkedIds.length === 0) {
        this.showToast('先选择再续费', 'error');
        return false;
      }
      this.$modal.show('renew-urgent-modal');
    },
    async confirmRenew(month, price) {
      if(month == null || isNaN(month) || month === 0) {
        this.$modal.hide('renew-urgent-modal');
        this.showToast('请填写月份', 'error');
        return false;
      }
      try {
        let params = {
          ids: this.checkedIds,
          duration: month,
          totalPrice: price
        };
        const res = await apis.usedRenew(JSON.stringify(params));
        this.$modal.hide('renew-urgent-modal');
        this.showToast('续费成功', 'correct');
        this.pageNumber = 1;
        this.fetchStoreList('reset');
        this.checkedIds = [];
        this.isShowCheck = false;
      } catch(err) {
        this.showToast('续费失败', 'error');
        console.error(err);
      }
    },
    loadmore(loaded) {
      if(this.storeTotal <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchStoreList().then(res => {
        loaded('done');
      });
    },
    async fetchStoreList(type = 'normal') {
      try {
        let params = {
          moduleOrderId: this.$route.params.id,
          no: this.pageNumber,
          limit: this.pageSize
        };
        const res = await apis.getOrderOpens(params);
        if(type === 'normal') {
          this.storeList = this.storeList.concat(res.records);
        } else {
          this.storeList = res.records;
        }
        this.storeTotal = res.total;
      } catch(err) {
        console.error(err);
      }
    },
    // 计算状态
    caclStatus(status) {
      switch (status) {
        case 0 :
        return '删除';
        case 1 :
        return '开启';
        case 2 :
        return '暂停';
        case 3 :
        return '转出';
      }
    },
    // 计算剩余时间
    caclAfterTime(expireTime) {
      let duration = moment(expireTime).valueOf() - moment().valueOf();
      let afterDays = parseInt(moment.duration(duration).asDays());
      if(afterDays >= 0) {
        return `${afterDays}天`;
      } else {
        return '已过期'; 
      }
    },
    // 计算此出显示
    caclText(item) {
      if(item.status === 3) {
        return '激活';
      } else {
        return `剩余时间：${this.caclAfterTime(item.expireTime)}`;
      }
    },
    ...mapMutations(['setCurrentStore'])
  },
  watch: {
    isShowCheck(nVal) {
      nVal ? this.$refs.operateList.style.marginBottom = '50px' : this.$refs.operateList.style.marginBottom = '0';
    }
  }
}
</script>

<style src="./index.scss" lang="scss" scoped></style>
